import { z } from "zod";

export const PriceSchema = z.object({
	id: z.number(),
	price: z.number(),
	perMonthOrYear: z.enum(["MONTH", "YEAR"]),
	productId: z.number(),
});

export type Price = z.infer<typeof PriceSchema>;
